import { store } from '@/store'
import { attachmentTypeApi } from '@/store/services'
import { toOptions } from '@/utils'
import { useTranslation } from 'react-i18next'
import { createSearchParams } from 'react-router-dom'
import { AsyncPaginate } from 'react-select-async-paginate'
import { SelectWrapper } from '../wrapper'
import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

export const AttachmentTypeSelector = ({ onChange, value, klasses = [] }) => {
  const [selectedOption, setSelectedOption] = useState({})
  const { t } = useTranslation()

  const getCurrentAttachmentType = useCallback(async (attachmentTypeId) => {
    try {
      const currentAttachmentType = await store.dispatch(
        attachmentTypeApi.endpoints.getAttachmentType.initiate(attachmentTypeId)
      ).unwrap()

      setSelectedOption(toOptions({ data: [currentAttachmentType] })[0])
    } catch ({ response }) { }
  }, [])

  const attachmentTypeLoadOptions = async (search, _loadedOptions, { page }) => {
    const params = new URLSearchParams({
      page,
      q: search,
      per_page: 10
    })

    // Backend expects klass[] to build arrays; repeated "klass" would be overwritten.
    klasses.forEach((klass) => params.append('klass[]', klass))

    const searchParams = params.toString()

    const { attachmentTypes, meta } = await store.dispatch(
      attachmentTypeApi.endpoints.getAttachmentTypes.initiate(`?${searchParams}`)
    ).unwrap()

    const options = toOptions({ data: attachmentTypes })
    const hasMore = page < meta.pagination.total_pages

    return {
      options,
      hasMore,
      additional: {
        page: page + 1
      }
    }
  }

  // Si el selector esta en un popover o modal, se pierde el selectedOption
  // Esta es una forma para rescatarlo si es que se pierde el estado.
  useEffect(() => {
    if (!value) {
      setSelectedOption({})
      return
    }

    if (value === selectedOption.value) return

    getCurrentAttachmentType(value)
  }, [value])

  const handleChange = (option) => {
    setSelectedOption(option)
    onChange(option)
  }

  return (
    <SelectWrapper label='Tipo de documento'>
      {(styles) => (

        <AsyncPaginate
          isClearable
          placeholder={t('select.one')}
          styles={styles}
          menuPortalTarget={document.body}
          menuPosition='fixed'
          options={[]}
          value={isEmpty(selectedOption) ? null : selectedOption}
          loadingMessage={() => t('select.loading')}
          onChange={handleChange}
          debounceTimeout={600}
          loadOptions={attachmentTypeLoadOptions}
          additional={{
            page: 1
          }}
        />
      )}
    </SelectWrapper>
  )
}

AttachmentTypeSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number,
  klasses: PropTypes.arrayOf(PropTypes.string)
}
